// Captures password-recovery intent from the initial URL BEFORE the Supabase
// client parses and strips the auth hash/query params on module init.
// Without this, the recovery link silently signs the user in and the /auth page
// redirects home instead of showing the "set a new password" form.

const detect = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const query = new URLSearchParams(window.location.search);
    if (hash.get("type") === "recovery" || query.get("type") === "recovery") return true;
    // PKCE flow: recovery links arrive as ?code=... on the reset redirect route
    if (query.has("code") && window.location.pathname.startsWith("/auth")) return true;
    return false;
  } catch {
    return false;
  }
};

let recoveryFromUrl = detect();

export const isRecoveryFromUrl = () => recoveryFromUrl;
export const clearRecoveryFromUrl = () => {
  recoveryFromUrl = false;
};
